import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { getInvoiceAttachments } from '../services/getInvoiceAttachments';

export const loadInvoiceAttachments = createAsyncThunk(
  'saleInvoices/loadInvoiceAttachments',
  async (params, { getState }) => {
    const { invoiceId } = params;

    if (!invoiceId) {
      throw new Error('No invoice id provided');
    }

    const selectedProjectId = selectSelectedProjectId(getState());

    const response = await getInvoiceAttachments(selectedProjectId, invoiceId);

    return response;
  }
);
